module.exports = "//public.getcloudapp.com/packs/media/images/annotate/rect-0fdfec43e5a6c21a034f1fa0a525e04c.svg";